import ComparativeAnalysis from '../images/Comparative Analysis.png';
import CompliancePerformance from '../images/Compliance Performance.png';
import CoverageAnalysis from '../images/Coverage Analysis.png';
import IndustryInsights from '../images/Industry Insights.png';
import { authFetchBlobUrl } from '../services/authFetch';

export function formatViewData(rawViews) {
    const newViews = {};

    for (const rawView of rawViews) {
        if (newViews.hasOwnProperty(rawView.categoryName)) {
            newViews[rawView.categoryName].push(rawView);
        }
        else {
            newViews[rawView.categoryName] = [rawView];
        }
    }

    return newViews;
};

export function prepViewsForDisplay(views) {
    return Object
        .entries(views)
        .sort((a, b) => a[0].localeCompare(b[0]));
};

const staticImageByView = {
    "ComparativeAnalysis": ComparativeAnalysis,
    "IndustryInsights": IndustryInsights,
    "CoverageAnalysis": CoverageAnalysis,
    "CompliancePerformance": CompliancePerformance,
}

async function fetchThumbnailBlobUrl(item) {
    const url = `${window.AnalyticsPortalConfig.apiAddress}/LandingItems/thumbnail/${item.workbookId}/${item.viewId}`;
    try {
        return await authFetchBlobUrl(url);
    } catch {
        return url;
    }
}

export async function getThumbnail(item, replaceWithStatic = false) {
    if (!replaceWithStatic) return await fetchThumbnailBlobUrl(item);

    // example item.viewName: SLABrokerCompliancePerformance_16680227049920/CompliancePerformance
    const regexResult = /^\w+\/(\w+)/.exec(item.viewName);

    if (regexResult === null) {
        return await fetchThumbnailBlobUrl(item);
    }

    const key = regexResult[1];

    return staticImageByView[key] || await fetchThumbnailBlobUrl(item);
};
